import { j as B } from "../../jsx-runtime-p91LotPX.mjs";
import * as o from "react";
import { t as G, q as S, g as R, m as H, b as V, a as T, s as A } from "../../index-CjjiqU7h.mjs";
import { c as F } from "../../reactNode-CwSzDQK_.mjs";
import { K as P } from "../../Keyframes-2v50Jp-S.mjs";
function W(e, t, i) {
  var n = i || {}, a = n.noTrailing, s = a === void 0 ? !1 : a, c = n.noLeading, p = c === void 0 ? !1 : c, u = n.debounceMode, d = u === void 0 ? void 0 : u, l, m = !1, f = 0;
  function $() {
    l && clearTimeout(l);
  }
  function C(r) {
    var v = r || {}, g = v.upcomingOnly, y = g === void 0 ? !1 : g;
    $(), m = !y;
  }
  function w() {
    for (var r = arguments.length, v = new Array(r), g = 0; g < r; g++)
      v[g] = arguments[g];
    var y = this, h = Date.now() - f;
    if (m)
      return;
    function b() {
      f = Date.now(), t.apply(y, v);
    }
    function E() {
      l = void 0;
    }
    !p && d && !l && b(), $(), d === void 0 && h > e ? p ? (f = Date.now(), s || (l = setTimeout(d ? E : b, e))) : b() : s !== !0 && (l = setTimeout(d ? E : b, d === void 0 ? e - h : e));
  }
  return w.cancel = C, w;
}
function K(e, t, i) {
  var n = i || {}, a = n.atBegin, s = a === void 0 ? !1 : a;
  return W(e, t, {
    debounceMode: s !== !1
  });
}
function U(e) {
  let {
    percent: t,
    prefixCls: i
  } = e;
  const n = `${i}-dot`, a = `${n}-holder`, s = `${a}-hidden`, [c, p] = o.useState(!1);
  G(() => {
    t !== 0 && p(!0);
  }, [t !== 0]);
  const u = Math.max(Math.min(t, 100), 0), d = 100, l = d / 5, m = d / 2 - l / 2, f = m * 2 * Math.PI, $ = (C, w) => /* @__PURE__ */ o.createElement("circle", {
    className: S(C, `${n}-circle`),
    r: m,
    cx: "50",
    cy: "50",
    strokeWidth: l,
    style: w
  });
  return c ? /* @__PURE__ */ o.createElement("span", {
    className: S(a, `${n}-progress`, u <= 0 && s)
  }, /* @__PURE__ */ o.createElement("svg", {
    viewBox: `0 0 ${d} ${d}`,
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": u
  }, $(`${n}-circle-bg`), $("", {
    strokeDasharray: `${f * u / 100} ${f * (100 - u) / 100}`,
    strokeDashoffset: `${f / 4}`
  }))) : null;
}
function J(e) {
  const {
    prefixCls: t,
    percent: i = 0
  } = e, n = `${t}-dot`, a = `${n}-holder`, s = `${a}-hidden`;
  return /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("span", {
    className: S(a, i > 0 && s)
  }, /* @__PURE__ */ o.createElement("span", {
    className: S(n, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((c) => /* @__PURE__ */ o.createElement("i", {
    className: `${t}-dot-item`,
    key: c
  })))), /* @__PURE__ */ o.createElement(U, {
    prefixCls: t,
    percent: i
  }));
}
function Q(e) {
  const {
    prefixCls: t,
    indicator: i,
    percent: n
  } = e, a = `${t}-dot`;
  return i && /* @__PURE__ */ o.isValidElement(i) ? F(i, {
    className: S(i.props.className, a),
    percent: n
  }) : /* @__PURE__ */ o.createElement(J, {
    prefixCls: t,
    percent: n
  });
}
const Y = new P("antSpinMove", {
  to: {
    opacity: 1
  }
}), Z = new P("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), k = (e) => {
  const {
    componentCls: t,
    calc: i
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, V(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: i(i(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: i(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: i(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: i(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: i(i(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: i(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: i(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: i(i(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: i(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: i(e.dotSize).sub(i(e.marginXXS).div(2)).div(2).equal(),
          height: i(e.dotSize).sub(i(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: Y,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: Z,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((n) => `${n} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: i(i(e.dotSizeSM).sub(i(e.marginXXS).div(2))).div(2).equal(),
          height: i(i(e.dotSizeSM).sub(i(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: i(i(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: i(i(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, ee = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: i
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: i
  };
}, te = R("Spin", (e) => {
  const t = H(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [k(t)];
}, ee), ie = 200, M = [[30, 0.05], [70, 0.03], [96, 0.01]];
function ne(e, t) {
  const [i, n] = o.useState(0), a = o.useRef(), s = t === "auto";
  return o.useEffect(() => (s && e && (n(0), a.current = setInterval(() => {
    n((c) => {
      const p = 100 - c;
      for (let u = 0; u < M.length; u += 1) {
        const [d, l] = M[u];
        if (c <= d)
          return c + p * l;
      }
      return c;
    });
  }, ie)), () => {
    clearInterval(a.current);
  }), [s, e]), s ? i : t;
}
var oe = function(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (i[n[a]] = e[n[a]]);
  return i;
};
let L;
function ae(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const O = (e) => {
  const {
    prefixCls: t,
    spinning: i = !0,
    delay: n = 0,
    className: a,
    rootClassName: s,
    size: c = "default",
    tip: p,
    wrapperClassName: u,
    style: d,
    children: l,
    fullscreen: m = !1,
    indicator: f,
    percent: $
  } = e, C = oe(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: w
  } = o.useContext(T), r = w("spin", t), [v, g, y] = te(r), [h, b] = o.useState(() => i && !ae(i, n)), E = ne(h, $);
  o.useEffect(() => {
    if (i) {
      const x = K(n, () => {
        b(!0);
      });
      return x(), () => {
        var I;
        (I = x == null ? void 0 : x.cancel) === null || I === void 0 || I.call(x);
      };
    }
    b(!1);
  }, [n, i]);
  const z = o.useMemo(() => typeof l < "u" && !m, [l, m]);
  if (process.env.NODE_ENV !== "production") {
    const x = A("Spin");
    process.env.NODE_ENV !== "production" && x(!p || z || m, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const {
    direction: j,
    spin: N
  } = o.useContext(T), q = S(r, N == null ? void 0 : N.className, {
    [`${r}-sm`]: c === "small",
    [`${r}-lg`]: c === "large",
    [`${r}-spinning`]: h,
    [`${r}-show-text`]: !!p,
    [`${r}-rtl`]: j === "rtl"
  }, a, !m && s, g, y), _ = S(`${r}-container`, {
    [`${r}-blur`]: h
  }), X = Object.assign(Object.assign({}, N == null ? void 0 : N.style), d), D = /* @__PURE__ */ o.createElement("div", Object.assign({}, C, {
    style: X,
    className: q,
    "aria-live": "polite",
    "aria-busy": h
  }), /* @__PURE__ */ o.createElement(Q, {
    prefixCls: r,
    indicator: f ?? L,
    percent: E
  }), p && (z || m) ? /* @__PURE__ */ o.createElement("div", {
    className: `${r}-text`
  }, p) : null);
  return v(z ? /* @__PURE__ */ o.createElement("div", Object.assign({}, C, {
    className: S(`${r}-nested-loading`, u, g, y)
  }), h && /* @__PURE__ */ o.createElement("div", {
    key: "loading"
  }, D), /* @__PURE__ */ o.createElement("div", {
    className: _,
    key: "container"
  }, l)) : m ? /* @__PURE__ */ o.createElement("div", {
    className: S(`${r}-fullscreen`, {
      [`${r}-fullscreen-show`]: h
    }, s, g, y)
  }, D) : D);
};
O.setDefaultIndicator = (e) => {
  L = e;
};
process.env.NODE_ENV !== "production" && (O.displayName = "Spin");
const re = O;
function ue() {
  return /* @__PURE__ */ B.jsx(re, { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  } });
}
export {
  ue as CustomLoadingOverlay
};
//# sourceMappingURL=LodingOverlay.js.map
